
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PhysicianTable from '../../components/PhysicianTable';


function DPhysicianTable({
  defaultStartDate,
  defaultEndDate,
  endDate,
  startDate,
  filter,
}) {
  const { departmentId } = useParams();
  return <PhysicianTable departmentId={departmentId}/>
}

export default DPhysicianTable;
